import { render, staticRenderFns } from "./group-view-panel.vue?vue&type=template&id=5dee6344&scoped=true&"
import script from "./group-view-panel.vue?vue&type=script&lang=js&"
export * from "./group-view-panel.vue?vue&type=script&lang=js&"
import style0 from "./group-view-panel.vue?vue&type=style&index=0&id=5dee6344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee6344",
  null
  
)

export default component.exports